export const NAVIGATION_SECTIONS = [
  {
    id: 10,
    path: "/home",
    section: "home",
    visibleFor: "desktop",
    isRoute: true,
    label: "Home",
    isHideable: false,
    isIcon:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? false
        : true,
  },
  {
    id: 1,
    path: "/sport",
    section: "sport",
    visibleFor: "both",
    isRoute: true,
    label:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? "SPORTS"
        : "Sport",
    isHideable: true,
    isIcon:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? false
        : true,
  },
  {
    id: 2,
    path: "/livebetting",
    section: "live",
    visibleFor: "both",
    isRoute: true,
    label:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? "LIVE SPORTS"
        : "In-Play",
    isHideable: true,
    isIcon:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? false
        : true,
  },
  {
    id: 6,
    path: "",
    section: "coupon",
    visibleFor: "mobile",
    isRoute: false,
    label:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? "COUPON"
        : "Coupon",
    isHideable: true,
    isIcon:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? false
        : true,
  },
  {
    id: 3,
    path: "/casino",
    section: "casino",
    visibleFor: "both",
    isRoute: true,
    label:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? "CASINO"
        : "Casino",
    isHideable: false,
    isIcon:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? false
        : true,
  },
  {
    id: 4,
    path: "/casinolive",
    section: "casino live",
    visibleFor: "both",
    isRoute: true,
    label:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? "LIVE CASINO"
        : "Casino Live",
    isHideable: false,
    isIcon:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? false
        : true,
  },
  {
    id: 5,
    path: "/virtual",
    section: "virtual",
    visibleFor: "both",
    isRoute: true,
    label:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? "VIRTUAL"
        : "Virtual",
    isHidable: false,
    isIcon:
      process.env.REACT_APP_SKIN && process.env.REACT_APP_SKIN === "planeth24"
        ? false
        : true,
  },
];

export const COUPON_UPDATE_INTERVAL_TIMING = 7000;
